import gql from 'graphql-tag';
import { sessionReportLayoutFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const updateDefaultSessionReportLayoutMutation = gql`
  mutation UpdateDefaultSessionReportLayout($input: UpdateDefaultSessionReportLayoutInput!) {
    updateDefaultSessionReportLayout(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminSessionReportLayoutFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${sessionReportLayoutFieldsFragment}
`;